import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { baseTransitionSecond, grayscaleFilter, grayscaleFilterTop } from 'style/variables';

type GrayCoverProps = {
  isHovered?: boolean;
  maskImage?: string;
  rendered?: boolean;
};

const GrayCoverWrap = styled.div<{ isHovered?: boolean; rendered?: boolean }>`
  position: absolute !important;
  inset: 0;
  backdrop-filter: ${grayscaleFilter};
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transition: background-color linear 2ms;
  background-color: ${({ rendered }) => (rendered ? 'transparent' : 'black')};

  @keyframes hover-reverse {
    0% {
      backdrop-filter: none;
    }
    to {
      backdrop-filter: ${grayscaleFilter};
    }
  }
  animation: hover-reverse ${baseTransitionSecond * 6}s ease-in-out forwards;

  ${({ isHovered, rendered }) =>
    isHovered &&
    rendered &&
    css`
      @keyframes fadeOutGray {
        0% {
          backdrop-filter: ${grayscaleFilter};
        }
        10% {
          backdrop-filter: ${grayscaleFilterTop};
        }
        100% {
          backdrop-filter: none;
        }
      }
      animation: fadeOutGray ${baseTransitionSecond * 6}s ease-in-out forwards;
      animation-delay: ${baseTransitionSecond * 4.5}s;
    `}
`;

const BlendImage = styled.img<{ isHovered?: boolean; rendered?: boolean }>`
  inset: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  position: absolute !important;
  mask-repeat: no-repeat;
  mask-position: center center;
  mask-size: cover;
  mix-blend-mode: color;
  opacity: 1;
  transition: background-color linear 2ms;
  background-color: ${({ rendered }) => (rendered ? 'transparent' : 'black')};
  ${({ isHovered, rendered }) =>
    isHovered &&
    rendered &&
    css`
      @keyframes mask-animation {
        0% {
          opacity: 1;
        }
        16% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      animation: mask-animation ${baseTransitionSecond * 6.5}s ease-in-out forwards;
      animation-delay: ${baseTransitionSecond * 4.5}s;
    `}
`;

const GrayCoverFV: React.FC<GrayCoverProps> = ({ isHovered, maskImage, rendered }) => {
  if (!maskImage) {
    return <GrayCoverWrap isHovered={isHovered} rendered={rendered} />;
  }

  return (
    <>
      <BlendImage src={maskImage} isHovered={isHovered} rendered={rendered} />
      <GrayCoverWrap isHovered={isHovered} rendered={rendered} />
    </>
  );
};

export default GrayCoverFV;
